import React from 'react';
import { PHASE_ORDER, ROLE_LABELS } from '../domain/constants';

// P · D · C · A nell'intestazione.
//
// L'asta attraversa i quattro ruoli in ordine e ogni comando dipende da dove ci
// si trova: prima questa informazione stava solo nel titolo, come coda di testo
// (" — ruolo A"), e durante una fase di pausa spariva del tutto.
//
// `currentRole` puo essere nullo (asta finita o non ancora avviata): in quel
// caso nessuna fase risulta corrente.

export default function PhaseTrack({ currentRole }) {
    const currentIndex = PHASE_ORDER.indexOf(currentRole);

    return (
        <ol className="phase-track" aria-label="Avanzamento delle fasi">
            {PHASE_ORDER.map((role, index) => {
                // Con `currentRole` nullo indexOf vale -1: nessuna fase e in
                // corso e, se l'asta e finita, tutte risultano concluse.
                const isCurrent = index === currentIndex;
                const isDone = currentIndex === -1 ? false : index < currentIndex;
                const state = isCurrent ? ' is-current' : isDone ? ' is-done' : '';
                const label = ROLE_LABELS[role];

                return (
                    <li
                        key={role}
                        className={`phase-step${state}`}
                        data-role={role}
                        aria-current={isCurrent ? 'step' : undefined}
                    >
                        <abbr title={isCurrent ? `${label} — fase in corso` : label}>{role}</abbr>
                    </li>
                );
            })}
        </ol>
    );
}
